<script lang="ts">
	import type { IconSource } from '@steeze-ui/heroicons'

	interface Props {
		src: IconSource
		solid?: boolean
		outline?: boolean
		xSmall?: boolean
		small?: boolean
		medium?: boolean
		large?: boolean
		xLarge?: boolean
		xxLarge?: boolean
		label?: string
		class?: string
	}

	let {
		src,
		solid = true,
		outline = false,
		xSmall = false,
		small = false,
		medium = false,
		large = false,
		xLarge = false,
		xxLarge = false,
		label = null,
		class: className = '',
	}: Props = $props()

	const isSolid = solid && !outline
</script>

<div
	class="
	  inline-flex shrink-0
	  {xSmall ? 'h-2.5 w-2.5' : ''}
	  {small ? 'h-4 w-4' : ''}
	  {!xSmall && !small && !medium && !large && !xLarge && !xxLarge ? 'h-5 w-5' : ''}
	  {medium ? 'h-6 w-6' : ''}
	  {large ? 'h-7 w-7' : ''}
	  {xLarge ? 'h-10 w-10' : ''}
	  {xxLarge ? 'h-20 w-20' : ''}
	  {className}
	"
	aria-label={label}
	title={label}
>
	{#if src && typeof src === 'object' && src[solid ? 'solid' : 'default']}
		<svg
			class="h-full w-full"
			fill={isSolid ? 'currentColor' : 'none'}
			stroke={isSolid ? 'none' : 'currentColor'}
			viewBox={isSolid ? '0 0 20 20' : '0 0 24 24'}
			xmlns="http://www.w3.org/2000/svg"
		>
			{#each src[isSolid ? 'mini' : 'default'].path as att, index (index)}
				<path {...att}></path>
			{/each}
		</svg>
	{:else}
		{console.warn(`Icon source is invalid: ${src}`)}
	{/if}
</div>
